const quotes = [
  {
    quote:
      "Clear-sightedness, persistence, and transcendence can be excellent antidotes for ultimate peace of mind and buoyancy in life, and sometimes valuable cures against social and administrative bashing.",
    author: "Erik Pevernagie",
  },
  {
    quote:
      "Where would his torture be, indeed, if at every step the hope of succeeding upheld him?",
    author: "Albert Camus",
  },
  {
    quote:
      "I am no bird; and no net ensnares me: I am a free human being with an independent will.",
    author: "Charlotte Brontë, Jane Eyre",
  },
  {
    quote:
      "Lock up your libraries if you like; but there is no gate, no lock, no bolt that you can set upon the freedom of my mind.",
    author: "Virginia Woolf, A Room of One's Own",
  },
  {
    quote:
      "When a man is denied the right to live the life he believes in, he has no choice but to become an outlaw.",
    author: "Nelson Mandela",
  },
  {
    quote: "If you are going through hell, keep going.",
    author: "Winston S. Churchill ",
  },
  {
    quote:
      "You may encounter many defeats, but you must not be defeated. In fact, it may be necessary to encounter the defeats, so you can know who you are, what you can rise from, how you can still come out of it.",
    author: "Maya Angelou ",
  },
  {
    quote:
      "It has been said, 'time heals all wounds.' I do not agree. The wounds remain. In time, the mind, protecting its sanity, covers them with scar tissue and the pain lessens. But it is never gone.",
    author: "Rose Fitzgerald Kennedy ",
  },
  {
    quote: "The town was paper, but the memories were not.",
    author: "John Green, Paper Towns ",
  },
  {
    quote:
      "People have only as much liberty as they have the intelligence to want and the courage to take.",
    author: "Emma Goldman",
  },
];

export default quotes;
